// extracted by mini-css-extract-plugin
export default {"tour-guide__header":"TourGuide_tour-guide__header__2qEFg","tour-guide__content":"TourGuide_tour-guide__content__3jvM1","tour-guide__close":"TourGuide_tour-guide__close__3-LFE"};